import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MyPlayersPageRoutingModule } from './my-players-routing.module';

import { EmptyPageModule } from '../empty-page/empty-page.module';
import { MyPlayersPage } from './my-players.page';
import { TranslateModule } from '@ngx-translate/core';
import { PlayerItemModule } from '../_shared/components/player-item/player-item.module';
import { ListSearchModule } from '../_shared/components/list-search/list-search.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        MyPlayersPageRoutingModule,
        EmptyPageModule,
        TranslateModule.forChild(),
        PlayerItemModule,
        ListSearchModule
    ],
    declarations: [MyPlayersPage]
})
export class MyPlayersPageModule { }
